import React, { FC, useEffect, useMemo } from 'react'
import { observer } from 'mobx-react'
import { Icon, Empty } from '@cps'
import { buyTogetherMobx, storeMobx, themeMobx, locationMobx, deliveryMobx } from '@mobxStore'
import { find, forEach, keyBy, sortBy } from '@dt/fe-utils/dist/lodash'
import StoreItem from '../StoreItem'
import StoreSearch from '../StoreSearch'
import './index.scss'

import noStoreCloseImg from '@img/no-store-close.png'
import { cartMobx, restaurantConfig } from 'restaurant'

interface IProps {
  /** 是否开启lbs */
  isLBS?: boolean;
  targetType?: string;
  /** 选择门店 */
  onSelectStore?(store?: IViewStore): void;
  mapShow?(type: boolean): void;
  onSelectMap?(store?: IViewStore): void;
  isStoreMore?: boolean;
  setIsStoreMore?(type: boolean): void;
  searchTitle?: string;
}

const StoreList: FC<IProps> = ({ isLBS = false, targetType, onSelectStore, mapShow, setIsStoreMore, isStoreMore, searchTitle }) => {
  const { locationIsOpen } = locationMobx
  const maxHeight = document.body.offsetHeight - 360
  const { address } = deliveryMobx
  // 上拉事件
  const onChangeBox = () => {
    setIsStoreMore(!isStoreMore)
  }
  // 拼单门店筛选
  const getStoreList = useMemo(() => {
    switch (targetType) {
      case 'buyTogether':
        return storeMobx.viewStoreList.filter((store) => store.openSelfDelivery && store.isOpenBuyTogether)
      default:
        return storeMobx.viewStoreList.filter((store) => store.openSelfDelivery)
    }
  }, [storeMobx.viewStoreList])

  /** 外卖筛选 */
  const deliveryStoreClassify: {
    list?: IViewStore[];
    noUseList?: IViewStore[];
  } = useMemo(() => {
    // 拼单外卖门店
    let storeList = getStoreList
    const storeMap = deliveryMobx.storeIdToaddressMap
    const list = []
    const noUseList = []
    if (!isLBS && !deliveryMobx.address) {
      return {
        list: storeList,
        noUseList: [],
      }
    }
    forEach(storeList, (item) => {
      const isInArea = storeMap?.[item.storeId]?.inArea && storeMap?.[item.storeId]?.inCityId
      if (isInArea) {
        list.push(item)
      } else {
        noUseList.push(item)
      }
    })
    return {
      list,
      noUseList,
    }
  }, [storeMobx.viewStoreList, deliveryMobx.addressStoreList, isLBS])

  /** 显示地图 */
  const clearMore = (e) => {
    setIsStoreMore(false)
    const ev = e || window.event
    ev.stopPropagation()
  }
  useEffect(() => {
    if (!locationIsOpen) {
      setIsStoreMore(true)
    }
    if (deliveryMobx.address || (restaurantConfig?.lbs?.lat && restaurantConfig?.lbs?.lng)) {
      const thisPoint = deliveryMobx.address || { lat: restaurantConfig?.lbs?.lat, lng: restaurantConfig.lbs.lng }
      deliveryMobx.calcStoresInAddress(thisPoint)
    }
  }, [])

  return (
    <div className='store-list-box delivery' style={{ transform: `translateY(${isStoreMore ? (0 - maxHeight) + 'px' : '-88px'})` }}>
      <StoreSearch clearMore={clearMore} mapShow={mapShow} searchTitle={searchTitle} />
      <p className='store-list-sort-top' onClick={() => { onChangeBox() }}>
        {isStoreMore ? <Icon name='chevron-down' /> : <Icon name='chevron-up' />}
      </p>
      <div className='store-list-content' style={{ height: `${isStoreMore ? (212 + maxHeight) + 'px' : '300px'}` }}>
        {
          getStoreList.length ? (
            <>
              <div className='store-list-more'>
                <p className='store-list-title'>{i18n.t('location.storeCanDelivery')}</p>
                {!!address && (
                  <div className='store-address-title'>
                    <div className='store-address-lbs-wrapper'>
                      <Icon name='mubiao' />
                      <span>{address.address} {address.addressDetail}</span>
                    </div>
                  </div>
                )}
                {
                  deliveryStoreClassify.list?.map(store => <StoreItem isDelvery key={store.storeId} store={store} onSelectStore={onSelectStore} />)
                }
              </div>
              {!!deliveryStoreClassify.noUseList?.length && (
                <div className='store-list-more disabled'>
                  <p className='store-list-title'>{i18n.t('location.storeCannotDelivery')}</p>
                  {
                    deliveryStoreClassify.noUseList?.map(store => <StoreItem isDelvery key={store.storeId} store={store} onSelectStore={onSelectStore} />)
                  }
                </div>
              )}
              <p className='no-more'>{i18n.t('common.noMore')}</p>
            </>
          ) : (
            <Empty
              msg={i18n.t('store.noStoreCity')}
              iconType='dicon'
              iconName={themeMobx?.data?.abnormalStateSetting[3]?.icon}
              picUrl={themeMobx?.data?.abnormalStateSetting[3]?.pic || noStoreCloseImg}
              height='40vh'
            />
          )
        }
      </div>
    </div>
  )
}
export default observer(StoreList)
